function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_43",
  "data-name": "Ellipse 43",
  cx: 20,
  cy: 20,
  r: 20,
  transform: "translate(40) rotate(90)",
  fill: "#e41e15",
  opacity: 0.15
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "icn_close",
  d: "M23.658,21.289,30.8,14.144a1.674,1.674,0,0,0-2.368-2.368L21.29,18.921l-7.145-7.145a1.674,1.674,0,1,0-2.368,2.368l7.145,7.145-7.145,7.145A1.674,1.674,0,0,0,14.145,30.8l7.145-7.145L28.435,30.8A1.674,1.674,0,0,0,30.8,28.434Z",
  transform: "translate(-1.288 -1.289)",
  fill: "#e41e15",
  opacity: 0.5
});

var SvgBttnDelete = function SvgBttnDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bttn_delete_hover",
    "data-name": "bttn_delete hover",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBttnDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bttn_delete.b9852d7a.svg";
export { ForwardRef as ReactComponent };